import { html } from 'lit';
const Cylinder =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M4.267 5H19.08l.036.004c.387.037.722.26.983.54.268.288.508.688.71 1.204.402 1.03.691 2.619.691 5.002s-.29 3.973-.692 5.002q-.303.773-.71 1.204c-.26.28-.595.503-.982.54l-.036.004H4.267l-.108-.033c-.337-.104-.624-.351-.853-.642-.238-.304-.46-.71-.65-1.23C2.278 15.557 2 14.005 2 11.75s.277-3.807.657-4.845c.19-.52.41-.926.65-1.23.228-.29.515-.538.852-.642zm14.756 11.91c.104-.12.245-.337.388-.704.31-.79.589-2.173.589-4.456s-.28-3.666-.589-4.456c-.143-.367-.284-.584-.388-.703-.092.108-.219.304-.35.635-.306.776-.587 2.17-.587 4.524s.281 3.748.588 4.524c.13.33.257.527.35.636M17.351 6.5l-.072.174c-.405 1.024-.693 2.63-.693 5.076s.288 4.052.693 5.076q.034.09.072.174H4.576a1 1 0 0 1-.09-.103c-.119-.15-.27-.407-.42-.817-.3-.82-.566-2.184-.566-4.33s.266-3.51.565-4.33c.15-.41.302-.667.42-.817q.056-.07.091-.103z" clip-rule="evenodd"/>
  </svg>
`;
export default Cylinder;
